<reb-ngx-card bodyMarginTop="zero" [cardBodyContainer]="cardBodyContainer" >
  <ng-template #cardBodyContainer>
    <reb-ngx-line-chart 
      *ngIf="collectionOfPaymentActivityDates.length > 0"
      [xAxisData]="collectionOfPaymentActivityDates"
      [seriesData]="paymentActivitySeries"
    ></reb-ngx-line-chart>
    <reb-ngx-chart-fallback
      *ngIf="collectionOfPaymentActivityDates.length === 0"
      message="There is no data to show"
      mood="info">
    </reb-ngx-chart-fallback>
  </ng-template>
</reb-ngx-card>